import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "monthlyToggle",
    "yearlyToggle",
    "standardPrice",
    "premiumPrice",
    "premiumCrossPrice",
    "planFrequency",
    "standardButton",
    "premiumButton"
  ]

  static values = {
    standardMonthlyPrice: String,
    standardYearlyPrice: String,
    premiumMonthlyPrice: String,
    premiumYearlyPrice: String,
    premiumMonthlyCrossPrice: String,
    premiumYearlyCrossPrice: String,
    standardMonthlyPriceId: String,
    standardYearlyPriceId: String,
    premiumMonthlyPriceId: String,
    premiumYearlyPriceId: String,
    perMonthText: String,
    perYearText: String
  }

  connect() {
    // Set initial state to monthly
    this.switchToMonthly()
  }

  switchToMonthly(event) {
    if (event) {
      event.preventDefault()
    }

    // Update toggle states
    this.monthlyToggleTarget.classList.add('bg-blue', 'text-white')
    this.yearlyToggleTarget.classList.remove('bg-blue', 'text-white')

    // Update prices
    this.standardPriceTarget.textContent = this.standardMonthlyPriceValue
    this.premiumPriceTarget.textContent = this.premiumMonthlyPriceValue
    this.premiumCrossPriceTarget.textContent = this.premiumMonthlyCrossPriceValue

    // Update frequency text
    this.planFrequencyTargets.forEach(target => {
      target.textContent = this.perMonthTextValue
    })

    // Update button data attributes (using setAttribute for jQuery compatibility)
    this.standardButtonTarget.setAttribute('data-price-id', this.standardMonthlyPriceIdValue)
    this.premiumButtonTarget.setAttribute('data-price-id', this.premiumMonthlyPriceIdValue)
  }

  switchToYearly(event) {
    if (event) {
      event.preventDefault()
    }

    // Update toggle states
    this.yearlyToggleTarget.classList.add('bg-blue', 'text-white')
    this.monthlyToggleTarget.classList.remove('bg-blue', 'text-white')

    // Update prices
    this.standardPriceTarget.textContent = this.standardYearlyPriceValue
    this.premiumPriceTarget.textContent = this.premiumYearlyPriceValue
    this.premiumCrossPriceTarget.textContent = this.premiumYearlyCrossPriceValue

    // Update frequency text
    this.planFrequencyTargets.forEach(target => {
      target.textContent = this.perYearTextValue
    })

    // Update button data attributes (using setAttribute for jQuery compatibility)
    this.standardButtonTarget.setAttribute('data-price-id', this.standardYearlyPriceIdValue)
    this.premiumButtonTarget.setAttribute('data-price-id', this.premiumYearlyPriceIdValue)
  }
}
